interface LogoProps {
  scale?: number;
}

// Each row spells one word with the same 4-color palette tile design. We
// stagger the colors warm→cool→warm→cool on the top row and mirror them on
// the bottom so adjacent letters never share a hue, every column shows two
// different colors, and the eye gets pulled across both rows.
const TOP_LETTERS = [
  { l: 'D', c: 'var(--c-yellow)', g: 'var(--glow-yellow)' },
  { l: 'O', c: 'var(--c-red)', g: 'var(--glow-red)' },
  { l: 'N', c: 'var(--c-blue)', g: 'var(--glow-blue)' },
  { l: 'T', c: 'var(--c-purple)', g: 'var(--glow-purple)' },
];

const BOTTOM_LETTERS = [
  { l: 'M', c: 'var(--c-purple)', g: 'var(--glow-purple)' },
  { l: 'I', c: 'var(--c-blue)', g: 'var(--glow-blue)' },
  { l: 'S', c: 'var(--c-red)', g: 'var(--glow-red)' },
  { l: 'S', c: 'var(--c-yellow)', g: 'var(--glow-yellow)' },
];

function LetterTile({ l, c, g, scale, tilt }: { l: string; c: string; g: string; scale: number; tilt: number }) {
  return (
    <div
      style={{
        width: 32 * scale,
        height: 40 * scale,
        borderRadius: 6 * scale,
        background: c,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'Bungee, Impact',
        fontSize: 26 * scale,
        color: '#0E0B2E',
        boxShadow: `inset 0 ${3 * scale}px 0 rgba(255,255,255,0.4), inset 0 ${-3 * scale}px 0 rgba(0,0,0,0.18), 0 ${6 * scale}px 0 rgba(0,0,0,0.5), ${g}`,
        textShadow: '0 1px 0 rgba(255,255,255,0.3)',
        transform: `rotate(${tilt}deg)`,
      }}
    >
      {l}
    </div>
  );
}

export function Logo({ scale = 1 }: LogoProps) {
  return (
    <div
      style={{
        display: 'inline-flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 8 * scale,
      }}
    >
      <div style={{ display: 'flex', gap: 6 * scale, alignItems: 'center' }}>
        {TOP_LETTERS.map((b, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 6 * scale }}>
            <LetterTile l={b.l} c={b.c} g={b.g} scale={scale} tilt={i % 2 === 0 ? -2 : 2} />
            {i === 2 && (
              <span
                aria-hidden
                style={{
                  fontFamily: 'Bungee, Impact',
                  fontSize: 22 * scale,
                  color: 'var(--c-cyan)',
                  textShadow: 'var(--glow-cyan)',
                  marginTop: -22 * scale,
                  transform: 'translateY(-2px)',
                }}
              >
                ’
              </span>
            )}
          </div>
        ))}
      </div>
      <div style={{ display: 'flex', gap: 6 * scale }}>
        {BOTTOM_LETTERS.map((b, i) => (
          <LetterTile
            key={i}
            l={b.l}
            c={b.c}
            g={b.g}
            scale={scale}
            tilt={i % 2 === 0 ? 2 : -2}
          />
        ))}
      </div>
    </div>
  );
}

export function LogoSmall() {
  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        fontFamily: 'Bungee, Impact',
        fontSize: 14,
        letterSpacing: '0.04em',
      }}
    >
      <div style={{ display: 'flex', gap: 2 }}>
        {['var(--c-red)', 'var(--c-blue)', 'var(--c-yellow)', 'var(--c-purple)'].map((c, i) => (
          <div key={i} style={{ width: 5, height: 14, background: c, borderRadius: 1 }} />
        ))}
      </div>
      <span style={{ color: 'var(--ink)' }}>DON’T MISS</span>
    </div>
  );
}
